import { render, staticRenderFns } from "./InitiatedOrder.vue?vue&type=template&id=a5e6a556&"
import script from "./InitiatedOrder.vue?vue&type=script&lang=js&"
export * from "./InitiatedOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports